﻿import TmkTrademarkPage from "./tmkTrademarkPage";
import TmkActionDuePage from "./tmkActionDuePage";
import TmkCostTrackingPage from "./tmkCostTrackingPage";
import TmkConflictPage from "./tmkConflictPage";
import TmkCountryLaw from "./tmkCountryLawPage";
import PTOUpdateMainPage from "./tmkPTOUpdateMainPage";
import PTOUpdatePage from "./tmkPTOUpdatePage";
import TmkGlobalUpdate from "./tmkGlobalUpdate";
import TmkCostImportPage from "./tmkCostImportPage";
import TmkTrademarkExportPage from "./tmkTrademarkExportPage";


if (!window.tmkTrademarkPage) {
    window.tmkTrademarkPage = new TmkTrademarkPage();
}
if (!window.tmkTrademarkExportPage) {
    window.tmkTrademarkExportPage = new TmkTrademarkExportPage();
}



if (!window.tmkActionDuePage) {
    window.tmkActionDuePage = new TmkActionDuePage();
}

if (!window.tmkCostTrackingPage) {
    window.tmkCostTrackingPage = new TmkCostTrackingPage();
}

if (!window.tmkConflictPage) {
    window.tmkConflictPage = new TmkConflictPage();
}

if (!window.tmkCountryLawPage) {
    window.tmkCountryLawPage = new TmkCountryLaw();
}
if (!window.tmkPTOUpdateMainPage) {
    window.tmkPTOUpdateMainPage = new PTOUpdateMainPage();
}
if(!window.tmkPTOUpdateBiblioPage) {
    window.tmkPTOUpdateBiblioPage = new PTOUpdatePage();
}
if (!window.tmkPTOUpdateTrademarkNamePage) {
    window.tmkPTOUpdateTrademarkNamePage = new PTOUpdatePage();
}
if (!window.tmkPTOUpdateActionPage) {
    window.tmkPTOUpdateActionPage = new PTOUpdatePage();
}
if (!window.tmkGlobalUpdate) {
    window.tmkGlobalUpdate = new TmkGlobalUpdate();
}
if (!window.tmkCostImportPage) {
    window.tmkCostImportPage = new TmkCostImportPage();
}
